import { useLocation } from "react-router"
import { Header } from "../../../components/header/header"
import { CheckListItem } from "./checkListItem"
import { useEffect, useLayoutEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import { CoffeCupIcon } from "../../../assets/icons"
import { ScrollableMenu } from "../../../components/scrollableMenu/scrollableMenu"
import { PageLoader } from "../../../components/loader/pageLoader"
import CheckListAPI from "../../../api/CheckListAPI"
import qs from "qs";

import { Text } from "../../../components/text/text";

import styles from "./checkList.module.css"

export const CheckListPage = () => {
    const { search } = useLocation();
    const searchParams = qs.parse(search.replace("?", ""));

    const cafeId = useSelector(state => state?.user?.userData?.cafeId);
    const [pageLoading, setPageLoading] = useState(true);
    const [tabId, setTabId] = useState(null);
    const [checklistCategories, setChecklistCategories] = useState([]);
    useEffect(() => {
        if (!cafeId) return;

        CheckListAPI
            .fetchUserChecklistCategories()
            .then((res) => {
                setChecklistCategories(res);
            })
            .catch(console.error)
            .finally(() => setPageLoading(false));
    }, [cafeId]);

    useEffect(() => {
        if (!tabId) {
            if (searchParams.initialTab) {
                setTabId(+searchParams.initialTab);
            } else if (checklistCategories[0]) {
                setTabId(+checklistCategories[0].id);
            }
        }
    }, [searchParams, checklistCategories, tabId]);

    const [items, setItems] = useState([]);

    const checkListItemsRefs = useRef({});

    const isScrolled = useRef(false);
    useLayoutEffect(() => {
        if (searchParams.scrollToTaskId && items.length > 0 && !isScrolled.current) {
            const el = checkListItemsRefs.current[searchParams.scrollToTaskId];
            if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: "instant", block: "center" });
            }
            isScrolled.current = true;
        }
    }, [items, searchParams.scrollToTaskId]);

    const checkListId = useSelector(state => state.user.userData.checklistId);
    useEffect(() => {
        if (!checkListId || pageLoading || tabId === null) return;

        CheckListAPI
            .fetchDailyTasks(checkListId, tabId)
            .then(data => setItems(data))
            .catch(console.error);
    }, [checkListId, tabId, pageLoading]);

    if (pageLoading) {
        return <PageLoader />;
    }

    return (
        <>
            <Header title="Чек-Лист" />
            <ScrollableMenu
                buttons={checklistCategories}
                current={tabId}
                setCurrent={setTabId}
            />

            {
                items.length === 0 &&
                <div className={styles.no_elements_placeholder}>
                    <CoffeCupIcon className={styles.no_elements_icon} />
                    <Text as="div" variant="body" className={styles.no_elements_text} >
                        Задач данной категории пока что нет.
                    </Text>
                </div>
            }

            {
                items.length > 0 &&
                <div className={styles.check_list_items}>
                    {
                        items.map((item) => (
                            <div
                                key={item.id}
                                ref={el => {
                                    if (el) checkListItemsRefs.current[item.id] = el;
                                }}
                            >
                                <CheckListItem data={item} setData={setItems} tabId={tabId} />
                            </div>
                        ))
                    }
                </div>
            }
        </>
    )
}
